// DTM
import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { BrowserView, MobileView } from "react-device-detect";
import text from "../helper/text";

import ArticleAbstract from "./ArticleAbstract";
import scale from "../helper/scaling";

const Wrapper = styled.div`
  float: left;
  width: 100%;
  height: 584px;
  @media (min-width: 1400px) {
    width: 1400px;
    padding: 0 calc(50% - 700px);
  }
  @media (max-width: 1100px) {
    height: auto;
  }
`;
const Display = styled.div`
  height: 584px;
  width: calc(100% - 50px);
  margin: 0 25px;
  float: left;
  background-color: #cfcfcf;
  overflow: hidden;
  position: relative;
  @media (max-width: 1100px) {
    height: 0;
    padding-bottom: 46%;
  }
  @media (max-width: 700px) {
    height: auto;
    width: 100%;
    margin: 0;
    padding: 0;
  }
`;
const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  @media (max-width: 700px) {
    position: relative;
    height: auto;
    float: left;
  }
`;
const Title = styled.div`
  width: 469px;
  height: 174px;
  font-family: Lato;
  font-size: 42px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.38;
  letter-spacing: 0.6px;
  color: #ffffff;
  position: absolute;
  left: 75px;
  top: 116px;
  @media (max-width: 1100px) {
    top: ${scale(506, 330, 116, 46, "%")};
    font-size: ${scale(1100, 767, 42, 31, "vw")};
    width: ${scale(1050, 717, 469, 352, "%")};
    height: ${scale(506, 330, 174, 125, "%")};
  }
  @media (max-width: 700px) {
    width: calc(100% - 46px);
    height: 290px;
    margin: 20px 23px;
    position: relative;
    left: 0;
    top: 0;
    float: left;

    font-size: 17px;
    line-height: 1.53;
    letter-spacing: 0.2px;
    text-align: center;
  }
`;
const TitleInner = styled.div`
  @media (max-width: 700px) {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }
`;
const ViewingsTitle = styled.div`
  height: 27px;
  font-family: Lato;
  font-size: 22px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.5px;
  color: rgba(255, 255, 255, 0.85);
  text-transform: uppercase;
  position: absolute;
  left: 75px;
  bottom: 191px;
  @media (max-width: 1100px) {
    font-size: ${scale(1100, 767, 22, 18, "vw")};
    bottom: ${scale(506, 330, 191, 119, "%")};
  }
  @media (max-width: 700px) {
    padding: 22px 35px 15px 35px;
    width: calc(100% - 70px);

    background-color: #f9f9f9;
    color: #000000;

    float: left;
    position: relative;
    left: 0;
    bottom: 0;

    height: auto;
    font-size: 16px;
    letter-spacing: 1.1px;
    text-align: center;
  }
`;
const Viewings = styled.div`
  height: 63px;
  font-family: Lato;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.31;
  letter-spacing: 1.1px;
  color: rgba(255, 255, 255, 0.85);
  text-transform: uppercase;
  position: absolute;
  bottom: 116px;
  left: 75px;
  @media (max-width: 1100px) {
    bottom: ${scale(506, 330, 116, 46, "%")};
  }
  @media (max-width: 700px) {
    padding: 0 35px 29px 35px;
    width: calc(100% - 70px);

    background-color: #f9f9f9;
    color: #000000;

    float: left;
    position: relative;
    left: 0;
    bottom: 0;

    height: auto;
    font-size: 12px;
    line-height: 1.33;
    letter-spacing: 0.8px;
    text-align: center;
  }
`;
const Line = styled.div``;
const VideoViewport = styled.div`
  width: 100%;
  height: 100%;
  float: left;
  overflow: hidden;
  position: relative;
  @media (max-width: 1100px) {
    position: absolute;
    top: 0;
    left: 0;
  }

  @media (max-width: 700px) {
    height: 330px;
  }
`;
const VideoContainer = styled.div`
  width: 100%;
  height: 1000px;
  position: absolute;
  left: 0;
  top: calc(50% - 500px);
  @media (max-width: 700px) {
    height: 500px;
    top: calc(50% - 250px);
    width: 110%;
    left: -5%;
  }
  @media (max-width: 600px) {
    height: 340px;
    top: -5px;
    width: 2000px;
    left: calc(50% - 1000px);
  }
`;
const Video = styled.video`
  width: 100%;
  height: 100%;
  float: left;
`;

// VideoContainer diff from zeplin padding: 35px;
const VideoHeaderEmblemContainer = styled.div`
  position: absolute;
  top: 75px;
  right: 40px;
  width: 404px;
  height: 407px;
  svg {
    width: 100%;
    height: 100%;
  }
  @media (max-width: 1100px) {
    top: ${scale(506, 330, 75, 33, "%")};
    right: ${scale(1050, 717, 40, 25, "%")};
    width: ${scale(1050, 717, 404, 242, "%")};
    height: ${scale(506, 330, 407, 243, "%")};
  }
  @media (max-width: 700px) {
    height: 176px;
    width: 176px;

    top: 55px;
    left: calc(50% - 88px);
  }
`;

class VideoHeader extends ArticleAbstract {
  objToArr = obj => {
    let returnable = [];
    for (let i in obj) {
      returnable.push(obj[i]);
    }
    return returnable;
  };

  txtDay = d =>
    text.getAsProp(this.props.translations, `day${((d + 6) % 7) + 1}`, -1);
  txtMonth = m =>
    text.getAsProp(
      this.props.translations,
      `month${m < 9 ? "0" : ""}${m + 1}`,
      -1
    );

  render() {
    let next = this.objToArr(this.props.calendar)
      .filter(i => i.end > new Date())
      .sort((a, b) => a.end > b.end)[0];
    let viewings = [];
    if (next && next.start) {
      viewings.push(new Date(next.start - (2 * 24 + 9) * 60 * 60 * 1000));
      viewings.push(new Date(next.start - (1 * 24 + 9) * 60 * 60 * 1000));
    }
    if (next && next.viewings && next.viewings.length > 0) {
      viewings = [];
      next.viewings.forEach(
        i => (i && i.start ? viewings.push(i.start) : null)
      );
    }
    return (
      <Wrapper>
        <Display>
          <VideoViewport>
            <BrowserView>
              <VideoContainer>
                <Video
                  autoPlay
                  muted
                  loop
                  playsinline
                  webkit-playsInline
                >
                  {this.meta("sources", []).map(
                    s =>
                      typeof s === "string" || s instanceof String ? (
                        s.split(".")[s.split(".").length - 1].length < 5 ? (
                          <source
                            key={s}
                            src={s}
                            type={
                              "video/" + s.split(".")[s.split(".").length - 1]
                            }
                          />
                        ) : (
                          <source src={s} type="video/mp4" />
                        )
                      ) : (
                        <source src={s.url} type={s.type} />
                      )
                  )}
                </Video>
              </VideoContainer>
            </BrowserView>
            <MobileView
              style={{
                width: "100%",
                height: "100%",
                background: "center / cover url('cdn/background_mobile.jpg')"
              }}
            />
          </VideoViewport>

          <Overlay>
            <Title>
              <TitleInner>{this.title()}</TitleInner>
            </Title>
            <ViewingsTitle>Eerstvolgende kijkdagen</ViewingsTitle>
            <Viewings>
              {viewings.map((v, index) => (
                <Line key={index}>
                  {this.txtDay(v.getDay())} {v.getDate()}{" "}
                  {this.txtMonth(v.getMonth())} {v.getFullYear()}
                </Line>
              ))}
              <Line>10:00 tot 17:00 uur</Line>
            </Viewings>

            <VideoHeaderEmblemContainer>
              <VideoHeaderEmblem />
            </VideoHeaderEmblemContainer>
          </Overlay>
        </Display>
      </Wrapper>
    );
  }
}

const mapStateToProps = state => {
  return {
    calendar: state.calendar.data,
    translations: state.translations.data
  };
};

export default connect(
  mapStateToProps
)(VideoHeader);

class VideoHeaderEmblem extends Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="404"
        height="407"
        viewBox="0 0 404 407"
      >
        <defs>
          <filter
            id="a"
            width="134%"
            height="133.3%"
            x="-17.2%"
            y="-16.1%"
            filterUnits="objectBoundingBox"
          >
            <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
            <feGaussianBlur
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
              stdDeviation="18.5"
            />
            <feColorMatrix
              in="shadowBlurOuter1"
              result="shadowMatrixOuter1"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
            />
            <feMerge>
              <feMergeNode in="shadowMatrixOuter1" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>
        <g
          fill="none"
          fillRule="evenodd"
          filter="url(#a)"
          transform="translate(35 33)"
        >
          <path
            stroke="#FFF2DD"
            strokeLinecap="round"
            strokeWidth=".691"
            d="M229.92 73.109s77.635 30.349 77.635 110.102c0 79.754-69.519 122.896-108.337 122.896"
          />
          <path
            stroke="#3949AB"
            strokeWidth=".691"
            d="M204.933 305.146l10.437 3.846"
          />
          <path
            fill="#FFF2DD"
            d="M257.91 295.358c10.516.839 27.222 7.094 27.222 7.094s-17.84 7.969-28.356 7.13c-10.517-.84-23.784-6.917-23.62-8.982.147-1.835 14.238-6.08 24.754-5.242"
          />
          <path
            stroke="#3949AB"
            strokeWidth=".691"
            d="M225.745 299.949l16.325 1.302"
          />
          <path
            fill="#FFF2DD"
            d="M218.57 279.727c7.853-7.045 20.786-13.423 20.786-13.423s-3.406 17-11.258 24.043c-7.853 7.046-21.454 11.795-22.836 10.253-1.23-1.37 5.455-13.827 13.308-20.873"
          />
          <path
            stroke="#3949AB"
            strokeWidth=".691"
            d="M201.407 304.71l7.708-6.917"
          />
          <path
            fill="#FFF2DD"
            d="M247.455 264.404c4.788-9.4 13.92-19.889 13.92-19.889s3.582 16.963-1.204 26.364c-4.787 9.4-14.468 18.083-16.314 17.144-1.641-.836-1.188-14.218 3.598-23.619"
          />
          <path
            stroke="#3949AB"
            strokeWidth=".691"
            d="M240.445 293.892l4.7-9.229"
          />
          <path
            fill="#FFF2DD"
            d="M267.6 249.719c2.482-9.58 10.001-19.206 10.001-19.206s6.465 11.936 3.982 21.516c-2.482 9.58-11.708 17.202-13.589 16.715-1.672-.434-2.877-9.445-.394-19.025"
          />
          <path
            stroke="#FFF2DD"
            strokeWidth=".691"
            d="M262.574 278.864l7.522-14.044"
          />
          <path
            fill="#FFF2DD"
            d="M279.703 277.235c10.502-1.014 20.054 6.931 20.054 6.931s-8.182 6.258-18.682 7.272c-10.501 1.013-22.711-2.894-22.91-4.956-.177-1.832 11.037-8.233 21.538-9.247"
          />
          <path
            stroke="#3949AB"
            strokeWidth=".691"
            d="M251.068 287.167l10.308-.995"
          />
          <path
            fill="#FFF2DD"
            d="M295.153 254.22c9.874-3.717 19.373-1.578 19.373-1.578s-4.474 11.215-14.348 14.931c-9.873 3.715-21.811 2.799-22.541.86-.65-1.723 7.642-10.499 17.516-14.214"
          />
          <path
            stroke="#FFF2DD"
            strokeWidth=".691"
            d="M268.85 273.32l10.938-5.697"
          />
          <path
            fill="#FFF2DD"
            d="M307.287 223.146c7.933-6.955 18.187-8.792 18.187-8.792s-.848 12.568-8.78 19.522c-7.934 6.952-19.265 10.153-20.63 8.597-1.215-1.386 3.291-12.374 11.223-19.327"
          />
          <path
            stroke="#FFF2DD"
            strokeWidth=".691"
            d="M288.55 249.418l9.077-8.316"
          />
          <path
            fill="#FFF2DD"
            d="M318.196 178.939c6.482-8.323 15.952-8.87 15.952-8.87s1.787 9.314-4.695 17.638c-6.482 8.323-18.647 16.066-20.281 14.793-1.453-1.13 2.542-15.238 9.024-23.561"
          />
          <path
            stroke="#FFF2DD"
            strokeWidth=".691"
            d="M304.706 210.38l7.381-11.988"
          />
          <path
            fill="#FFF2DD"
            d="M310.11 147.125c3.514-9.946 11.561-13.552 12.322-13.465 2.744.313 4.645 8.27 1.132 18.217-3.514 9.948-11.34 18.46-13.293 17.77-1.736-.612-3.675-12.575-.161-22.522"
          />
          <path
            stroke="#FFF2DD"
            strokeWidth=".691"
            d="M307.452 178.223l3.865-13.097"
          />
          <path
            fill="#FFF2DD"
            d="M284.763 197.64c-6.085-8.617-3.215-22.573-3.215-22.573s7.87 3.355 13.954 11.972c6.086 8.62 5.977 19.071 4.285 20.266-1.504 1.063-8.939-1.046-15.024-9.664"
          />
          <path
            stroke="#FFF2DD"
            strokeWidth=".691"
            d="M303.98 213.535l-7.928-12.708"
          />
          <path
            fill="#FFF2DD"
            d="M285.853 166.978c-6.085-8.618-5.529-19.762-5.529-19.762s10.233.826 16.318 9.443c6.085 8.618 7.801 21.126 6.11 22.32-1.505 1.063-10.814-3.384-16.9-12.001"
          />
          <path
            stroke="#FFF2DD"
            strokeWidth=".691"
            d="M307.484 187.626l-8.557-15.524"
          />
          <path
            fill="#FFF2DD"
            d="M157.87 211.02c0 9.024-3.527 16.337-10.58 21.937-6.534 5.083-14.469 7.624-23.803 7.624-10.061 0-18.307-2.126-24.737-6.379-7.572-4.979-11.358-12.187-11.358-21.625 0-12.654 8.09-23.597 24.27-32.828-7.364-6.327-12.083-10.787-14.157-13.38-4.771-5.912-7.157-12.187-7.157-18.825 0-8.401 3.423-15.143 10.268-20.225 6.12-4.564 13.536-6.845 22.248-6.845 8.713 0 16.129 2.178 22.248 6.534 6.846 4.875 10.268 11.513 10.268 19.914 0 6.638-2.696 12.602-8.09 17.892-2.8 2.696-7.986 6.43-15.558 11.201 8.194 5.705 13.743 10.113 16.647 13.225 6.327 6.638 9.49 13.898 9.49 21.78zm-15.247-65.654c0-5.6-1.79-10.138-5.368-13.613-3.578-3.475-8.167-5.212-13.768-5.212-5.186 0-9.646 1.452-13.38 4.356-4.045 3.112-6.068 7.209-6.068 12.291 0 5.082 1.867 9.75 5.601 14.002 2.593 3.008 8.246 7.883 16.958 14.625 10.683-5.912 16.025-14.728 16.025-26.449zm1.245 70.167c0-8.194-9.024-18.722-27.071-31.583-9.957 7.157-14.936 16.595-14.936 28.315 0 5.29 1.504 10.01 4.512 14.158 4.149 5.601 10.372 8.401 18.67 8.401 5.29 0 9.75-1.893 13.38-5.678 3.63-3.786 5.445-8.324 5.445-13.613zm107.63-35.784c0 19.292-4.46 34.539-13.38 45.74-7.676 9.647-17.01 14.47-28.005 14.47-13.898 0-24.685-6.794-32.36-20.381-6.327-11.202-9.49-24.27-9.49-39.206 0-20.018 4.563-35.524 13.69-46.519 7.676-9.334 17.062-14.002 28.16-14.002 10.061 0 18.929 4.253 26.604 12.758 9.854 10.89 14.78 26.604 14.78 47.14zm-17.892-3.111c0-11.72-1.245-21.937-3.734-30.65-3.942-13.587-10.424-20.38-19.448-20.38-16.595 0-24.892 18.928-24.892 56.786 0 11.617 1.348 21.989 4.045 31.116 4.045 13.587 10.527 20.38 19.447 20.38 16.388 0 24.582-19.083 24.582-57.252zM291.44 111.996c-.387-10.542 6.514-17.05 6.514-17.05s7.359 5.986 7.744 16.529c.386 10.542-3.767 21.335-5.837 21.411-1.84.067-8.037-10.348-8.422-20.89"
          />
          <path
            stroke="#FFF2DD"
            strokeWidth=".691"
            d="M300.278 143.146l-1.104-14.851"
          />
          <path
            fill="#FFF2DD"
            d="M269.56 87.362c-2.062-9.266 1.579-18.03 1.579-18.03s8.892 5.975 10.955 15.241c2.062 9.268.037 21.147-1.783 21.552-1.618.36-8.69-9.495-10.752-18.763"
          />
          <path
            stroke="#FFF2DD"
            strokeWidth=".691"
            d="M281.583 111.845l-2.517-11.32"
          />
          <path
            fill="#FFF2DD"
            d="M294.112 222.192c-.594-10.695-7.403-19.537-8.169-19.67 0 0-6.88 6.74-6.286 17.434.595 10.696 8.53 21.905 8.53 21.905s6.52-8.975 5.925-19.67"
          />
          <path
            stroke="#FFF2DD"
            strokeWidth=".691"
            d="M288.55 249.418l-.726-13.065"
          />
          <path
            fill="#FFF2DD"
            d="M242.291 72.454c-5.088-7.564-3.44-15.003-2.987-15.486 0 0 8.129 1.04 13.217 8.604 5.087 7.564 6.428 17.38 4.943 18.378-1.32.888-10.085-3.933-15.173-11.496"
          />
          <path
            stroke="#FFF2DD"
            strokeWidth=".691"
            d="M261.227 91.918l-5.829-11.025"
          />
          <path
            fill="#FFF2DD"
            d="M215.985 63.824c-5.8-4.924-5.906-11.765-5.906-11.765s6.768-1.003 12.566 3.92c5.8 4.925 9.677 13.596 8.71 14.735-.86 1.011-9.57-1.966-15.37-6.89"
          />
          <path
            stroke="#FFF2DD"
            strokeWidth=".691"
            d="M237.701 76.751l-9.276-9.114"
          />
          <path
            fill="#FFF2DD"
            d="M240.184 99.347c-8.549-.176-13.496-6.063-13.496-6.063s5.185-5.678 13.735-5.5c8.55.175 18.561 4.895 18.527 6.573-.031 1.492-10.216 5.166-18.766 4.99"
          />
          <path
            stroke="#FFF2DD"
            strokeWidth=".691"
            d="M266.183 95.999l-12.45-2.157"
          />
          <path
            fill="#FFF2DD"
            d="M219.267 83.39c-8.532.583-14.774-5.692-14.774-5.692s3.518-3.247 12.05-3.83c8.531-.583 18.101 3.64 18.216 5.315.1 1.488-6.96 3.625-15.492 4.207"
          />
          <path
            stroke="#FFF2DD"
            strokeWidth=".691"
            d="M243.857 80.13l-13.519-1.407"
          />
          <path
            fill="#FFF2DD"
            d="M257.407 115.915c-9.469-3.073-13.065-10.579-13-11.299 0 0 9.127-3.16 18.596-.086 9.47 3.073 17.912 10.607 17.308 12.466-.536 1.653-13.436 1.993-22.904-1.08"
          />
          <path
            stroke="#FFF2DD"
            strokeWidth=".691"
            d="M288.984 121.484l-14.625-7.143"
          />
          <path
            fill="#FFF2DD"
            d="M293.732 144.303s-.469-21.899-30.73-18.316c0 0 10.429 19.792 30.73 18.316"
          />
          <path
            stroke="#FFF2DD"
            strokeWidth=".691"
            d="M289.838 144.224l-1.287-3.007 13.58 7.127"
          />
          <path
            stroke="#FF4D4D"
            strokeWidth=".691"
            d="M233.156 300.6l51.976 1.852M239.355 266.303l-34.24 35.224M261.376 245.323l-17.52 42.7M258.164 286.482l42.62-2.108M277.6 229.551l-9.606 39.192M314.525 252.642l-35.565 16.102M280.871 175.067l18.915 32.238M285.943 202.523l2.244 39.339M325.475 214.354l-29.411 28.118M334.148 170.068l-23.932 32.455M322.182 132.886l-11.911 36.762M280.324 147.216l22.207 31.007M262.373 125.591l31.36 18.712M297.627 92.649l2.234 40.237M242.998 104.914l37.312 12.082M271.284 68.562l9.027 37.563M225.891 93.842l33.06.515M238.688 56.06l18.776 27.89M203.642 77.98l30.265 1.484M208.772 51.06l22.583 19.653"
          />
          <path
            fill="#FF4D4D"
            d="M289.598 106.646a2.5 2.5 0 1 1-5-.001 2.5 2.5 0 0 1 5 .001M289.23 128.774a4.098 4.098 0 1 1-8.196 0 4.098 4.098 0 0 1 8.196 0M302.671 270.956a4.098 4.098 0 1 1-8.196 0 4.098 4.098 0 0 1 8.196 0M327.426 165.126a3.025 3.025 0 1 1-6.05 0 3.025 3.025 0 0 1 6.05 0M271.018 316.315a3.025 3.025 0 1 1-6.049 0 3.025 3.025 0 0 1 6.05 0M276.303 226.08a1.943 1.943 0 1 1-3.887.001 1.943 1.943 0 0 1 3.887 0M214.948 68.552a1.944 1.944 0 1 1-3.888.001 1.944 1.944 0 0 1 3.888 0M310.092 270.124a1.943 1.943 0 1 1-3.887 0 1.943 1.943 0 0 1 3.887 0"
          />
          <path
            fill="#FFF2DD"
            d="M115.854 279.727c-7.853-7.045-21.876-13.423-21.876-13.423s4.495 17 12.347 24.043c7.853 7.046 21.453 11.795 22.837 10.253 1.23-1.37-5.455-13.827-13.308-20.873"
          />
          <path
            stroke="#FF4D4D"
            strokeWidth=".691"
            d="M93.977 266.303l35.332 35.224"
          />
          <path
            stroke="#FFF2DD"
            strokeLinecap="round"
            strokeWidth=".691"
            d="M104.504 73.109S26.867 103.458 26.867 183.21c0 79.754 69.52 122.896 108.338 122.896"
          />
          <path
            stroke="#3949AB"
            strokeWidth=".691"
            d="M129.686 305.772l-10.633 3.22"
          />
          <path
            fill="#FFF2DD"
            d="M76.513 295.358c-10.515.839-27.222 7.094-27.222 7.094s17.84 7.969 28.356 7.13c10.517-.84 23.784-6.917 23.62-8.982-.146-1.835-14.238-6.08-24.754-5.242"
          />
          <path
            stroke="#3949AB"
            strokeWidth=".691"
            d="M108.679 299.949l-16.326 1.302"
          />
          <path
            fill="#FFF2DD"
            d="M86.967 264.404c-4.786-9.4-13.92-19.889-13.92-19.889s-3.582 16.963 1.205 26.364c4.787 9.4 14.467 18.083 16.313 17.144 1.642-.836 1.19-14.218-3.598-23.619"
          />
          <path
            stroke="#3949AB"
            strokeWidth=".691"
            d="M93.977 293.892l-4.7-9.229"
          />
          <path
            fill="#FFF2DD"
            d="M66.824 249.719c-2.483-9.58-10.003-19.206-10.003-19.206s-6.464 11.936-3.982 21.516c2.484 9.58 11.71 17.202 13.59 16.715 1.672-.434 2.876-9.445.395-19.025"
          />
          <path
            stroke="#FFF2DD"
            strokeWidth=".691"
            d="M69.894 277.644l-5.566-12.825"
          />
          <path
            fill="#FFF2DD"
            d="M54.72 277.235c-10.501-1.014-20.054 6.931-20.054 6.931s8.181 6.258 18.683 7.272c10.5 1.013 22.711-2.894 22.91-4.956.176-1.832-11.038-8.233-21.54-9.247"
          />
          <path
            stroke="#3949AB"
            strokeWidth=".691"
            d="M83.356 287.167l-10.31-.995"
          />
          <path
            fill="#FFF2DD"
            d="M39.27 254.22c-9.873-3.717-19.373-1.578-19.373-1.578s4.474 11.215 14.348 14.931c9.874 3.715 21.812 2.799 22.542.86.648-1.723-7.643-10.499-17.517-14.214"
          />
          <path
            stroke="#FFF2DD"
            strokeWidth=".691"
            d="M64.328 272.51l-9.694-4.887"
          />
          <path
            fill="#FFF2DD"
            d="M27.135 223.146c-7.933-6.955-18.187-8.792-18.187-8.792s.85 12.568 8.781 19.522c7.934 6.952 19.266 10.153 20.631 8.597 1.213-1.386-3.292-12.374-11.225-19.327"
          />
          <path
            stroke="#FFF2DD"
            strokeWidth=".691"
            d="M44.239 246.974l-7.442-5.872"
          />
          <path
            fill="#FFF2DD"
            d="M16.227 178.939c-6.482-8.323-15.952-8.87-15.952-8.87s-1.788 9.314 4.695 17.638c6.483 8.323 18.648 16.066 20.28 14.793 1.453-1.13-2.54-15.238-9.023-23.561"
          />
          <path
            stroke="#FFF2DD"
            strokeWidth=".691"
            d="M29.478 209.258l-7.141-10.866"
          />
          <path
            fill="#FFF2DD"
            d="M24.314 147.125C20.8 137.18 12.75 133.573 11.99 133.66c-2.744.313-4.645 8.27-1.132 18.217 3.514 9.948 11.34 18.46 13.294 17.77 1.736-.612 3.674-12.575.16-22.522"
          />
          <path
            stroke="#FFF2DD"
            strokeWidth=".691"
            d="M26.867 178.223l-3.762-13.097"
          />
          <path
            fill="#FFF2DD"
            d="M49.66 197.64c6.085-8.617 3.216-22.573 3.216-22.573s-7.87 3.355-13.955 11.972c-6.085 8.62-5.977 19.071-4.285 20.266 1.504 1.063 8.938-1.046 15.024-9.664"
          />
          <path
            stroke="#FFF2DD"
            strokeWidth=".691"
            d="M30.444 213.535l7.926-12.708"
          />
          <path
            fill="#FFF2DD"
            d="M48.57 166.978c6.086-8.618 5.528-19.762 5.528-19.762s-10.232.826-16.317 9.443c-6.086 8.618-7.802 21.126-6.11 22.32 1.504 1.063 10.814-3.384 16.9-12.001"
          />
          <path
            stroke="#FFF2DD"
            strokeWidth=".691"
            d="M26.867 186.757l8.628-14.654"
          />
          <path
            fill="#FFF2DD"
            d="M42.984 111.996c.386-10.542-6.515-17.05-6.515-17.05s-7.358 5.986-7.745 16.529c-.385 10.542 3.768 21.335 5.838 21.411 1.84.067 8.036-10.348 8.422-20.89"
          />
          <path
            stroke="#FFF2DD"
            strokeWidth=".691"
            d="M34.145 143.146l1.104-14.851"
          />
          <path
            fill="#FFF2DD"
            d="M64.863 87.362c2.062-9.266-1.58-18.03-1.58-18.03s-8.892 5.975-10.953 15.241c-2.062 9.268-.037 21.147 1.782 21.552 1.617.36 8.69-9.495 10.751-18.763"
          />
          <path
            stroke="#FFF2DD"
            strokeWidth=".691"
            d="M51.883 112.767l3.475-12.242"
          />
          <path
            fill="#FFF2DD"
            d="M40.31 222.192c.596-10.695 7.404-19.537 8.17-19.67 0 0 6.88 6.74 6.287 17.434-.596 10.696-8.53 21.905-8.53 21.905s-6.521-8.975-5.927-19.67"
          />
          <path
            stroke="#FFF2DD"
            strokeWidth=".691"
            d="M45.873 249.418l.727-13.065"
          />
          <path
            fill="#FFF2DD"
            d="M92.132 72.454c5.088-7.564 3.439-15.003 2.987-15.486 0 0-8.13 1.04-13.217 8.604-5.087 7.564-6.428 17.38-4.944 18.378 1.321.888 10.085-3.933 15.174-11.496"
          />
          <path
            stroke="#FFF2DD"
            strokeWidth=".691"
            d="M73.196 91.918l5.83-11.025"
          />
          <path
            fill="#FFF2DD"
            d="M118.439 63.824c5.798-4.924 5.904-11.765 5.904-11.765s-6.766-1.003-12.566 3.92c-5.8 4.925-9.677 13.596-8.71 14.735.86 1.011 9.572-1.966 15.372-6.89"
          />
          <path
            stroke="#FFF2DD"
            strokeWidth=".691"
            d="M97.88 76.16l8.118-8.523"
          />
          <path
            fill="#FFF2DD"
            d="M94.238 99.347c8.55-.176 13.497-6.063 13.497-6.063s-5.185-5.678-13.735-5.5c-8.55.175-18.561 4.895-18.526 6.573.03 1.492 10.216 5.166 18.764 4.99"
          />
          <path
            stroke="#FFF2DD"
            strokeWidth=".691"
            d="M68.042 96.169l12.648-2.327"
          />
          <path
            fill="#FFF2DD"
            d="M115.156 83.39c8.531.583 14.773-5.692 14.773-5.692s-3.517-3.247-12.049-3.83c-8.532-.583-18.102 3.64-18.216 5.315-.101 1.488 6.96 3.625 15.492 4.207"
          />
          <path
            stroke="#FFF2DD"
            strokeWidth=".691"
            d="M90.566 80.13l13.52-1.407"
          />
          <path
            fill="#FFF2DD"
            d="M77.017 115.915c9.468-3.073 13.064-10.579 13-11.299 0 0-9.128-3.16-18.597-.086-9.47 3.073-17.911 10.607-17.309 12.466.538 1.653 13.436 1.993 22.906-1.08"
          />
          <path
            stroke="#FFF2DD"
            strokeWidth=".691"
            d="M45.873 120.673l14.191-6.333"
          />
          <path
            fill="#FFF2DD"
            d="M40.69 144.303s.47-21.899 30.73-18.316c0 0-10.427 19.792-30.73 18.316"
          />
          <path
            stroke="#FFF2DD"
            strokeWidth=".691"
            d="M44.585 144.224l1.288-3.007-13.454 6.742"
          />
          <path
            stroke="#FF4D4D"
            strokeWidth=".691"
            d="M101.267 300.6l-51.976 1.852M73.047 245.323l17.519 42.7M76.26 286.482l-42.621-2.108M56.822 229.551l9.607 39.192M19.898 252.642l35.566 16.102M53.551 175.067l-18.915 32.238M48.48 202.523l-2.244 39.339M10.053 214.354l28.307 28.118M.276 170.068l24.603 32.455M12.241 132.886l11.965 36.075M54.098 147.216l-22.206 31.007M72.05 125.591l-31.325 18.205M36.797 92.649l-2.235 40.237M91.426 104.914l-37.314 12.082M63.14 68.562l-9.028 37.563M108.532 93.842l-33.058.515M95.736 56.06L76.958 83.95M130.781 77.98l-30.265 1.484M125.65 51.06l-22.583 19.653"
          />
          <path
            fill="#FF4D4D"
            d="M53.39 166.817a4.098 4.098 0 1 1-8.196 0 4.098 4.098 0 0 1 8.195 0M68.426 315.099a4.098 4.098 0 1 1-8.196.001 4.098 4.098 0 0 1 8.196-.001M29.892 136.064a3.025 3.025 0 1 1-6.05-.001 3.025 3.025 0 0 1 6.05 0M73.914 76.123a3.025 3.025 0 1 1-6.051-.002 3.025 3.025 0 0 1 6.05.002M60.423 160.775a1.944 1.944 0 1 1-3.889.001 1.944 1.944 0 0 1 3.889 0M38.74 248.599a1.944 1.944 0 1 1-3.887 0 1.944 1.944 0 0 1 3.888 0"
          />
          <path
            fill="#3949AB"
            d="M128.389 282.6H73.714l7.31 18.96-7.31 18.96h54.675z"
          />
          <path fill="#7F7B71" d="M104.016 306.6l24.806 13.92V306.6z" />
          <path
            fill="#3949AB"
            d="M206.036 282.6h54.674l-7.308 18.96 7.308 18.96h-54.674z"
          />
          <path fill="#5969C9" d="M104.04 306.6h126.368v-37.92H104.04z" />
          <text
            fill="#FFF2DD"
            fontFamily="Lato-Black, Lato"
            fontSize="21.197"
            fontWeight="700"
            letterSpacing="1.484"
          >
            <tspan x="139.184" y="294.715">
              JAAR
            </tspan>
          </text>
          <path fill="#7F7B71" d="M230.408 306.6l-24.805 13.92V306.6z" />
          <path
            fill="#FFF2DD"
            d="M231.964 313.163c10.011 5.306 26.594 21.83 26.594 21.83s-23.76-2.983-33.772-8.29c-10.011-5.306-20.494-17.016-19.453-18.982.925-1.749 16.62.135 26.63 5.442"
          />
          <path
            stroke="#FF4D4D"
            strokeWidth=".691"
            d="M205.333 307.72l53.226 26.754"
          />
          <path
            fill="#FFF2DD"
            d="M103.445 314.7c-9.663 5.918-25.189 23.44-25.189 23.44s23.529-4.452 33.193-10.37c9.663-5.918 19.398-18.258 18.237-20.154-1.033-1.688-16.58 1.166-26.241 7.084"
          />
          <path
            stroke="#FF4D4D"
            strokeWidth=".691"
            d="M129.686 307.615l-51.43 30.525"
          />
          <path
            fill="#3949AB"
            d="M195.535 26.419c0 1.205-1.231 2.6-2.436 2.6-1.205 0-1.93-1.395-1.93-2.6a2.182 2.182 0 1 1 4.366 0M203.444 68.552l-72.438-1.859v-4.067h72.438z"
          />
          <path
            fill="#FF4D4D"
            d="M197.491 41.33c-5.91-2.44-4.925-11.573-4.925-11.573s-9.38 13.946-18.174 9.125c-2.907-1.594-4.546-4.81-4.546-8.123v-1.97c0-2.693.664-5.341 1.935-7.714a4.13 4.13 0 0 1 3.755-2.178l14.476.4s-7.475-12.898-16.585-7.014C174.49 9.627 177.388.55 167.573.021c-10.535-.57-6.905 10.846-6.219 12.777-1.413-1.321-3.3-2.406-5.804-2.62-7.254-.623-9.43 8.499-9.43 8.499h8.444c2.201 0 4.364.763 5.99 2.246 3.014 2.753 4.709 6.306 4.709 10.71.1 1.578-.362 3.173-1.415 4.352-4.484 5.02-14.368 7.704-20.037-6.228 0 0-5.665 23.639-20.684 2.955l8.987 27.704 71.533.122 9.357-26.663s-5.91 11.395-15.513 7.455"
          />
          <path
            fill="#FFF2DD"
            d="M172.21 7.226a4.986 4.986 0 1 1-9.97 0 4.986 4.986 0 0 1 9.97 0"
          />
          <path
            fill="#3949AB"
            d="M170.426 7.226c0 1.768-.854 3.201-3.201 3.201a3.2 3.2 0 0 1-3.201-3.2c0-1.768 1.432-3.51 3.2-3.51 1.768 0 3.202 1.742 3.202 3.51M145.534 25.324a2.338 2.338 0 1 1-4.677 0 2.338 2.338 0 0 1 4.677 0"
          />
          <path
            fill="#FFF2DD"
            d="M188.811 41.208l-5.54 7.017 2.77 7.757 7.312-6.095zM143.196 41.208l-1.479 9.049 7.018 5.725 1.108-7.387zM167.225 41.208l-4.987 7.387 4.094 6.974 4.095-6.974zM148.919 17.106s6.188-9.88 10.157 0h-10.157zM172.897 16.793s4.63-10.414 12.812.61l-12.812-.61zM169.297 17.814a2.462 2.462 0 1 1-4.925 0 2.462 2.462 0 0 1 4.925 0"
          />
          <path
            stroke="#FF4D4D"
            strokeWidth=".691"
            d="M131.006 69.332l72.438 1.17"
          />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/VideoHeader.js